Vue.component('ack-alpha-ai', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-alpha-ai',
	mixins: [languageMixins],
	created() {
		this.PRODUCT = PRODUCT_INFO ? PRODUCT_INFO : null;
	},
	mounted() {
		appLog.log('ack-alpha-ai mounted');
	},
	props: {
		// dataIn: {
		//   type: Object,
		//   required: true
		// }
	},
	computed: {
		//...Vuex.mapGetters('sliders', ['slidersLists']),
		//...Vuex.mapGetters('articles', ['articlesArray']),
		isMobile() {
			return this.$parent.isMobile;
		},
	},
	data() {
		return {
			PRODUCT: null,
			pageId: 'alpha-ai-page',
			alphaAiInfo: {
				title_section: {
					id: 'gid://shopify/Product/6643132235879',
					title: 'alpha_ai.title_section.title',
					subtitle: 'alpha_ai.title_section.subtitle',
					title_img:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Logo_Resize-07.png?v=1704958182',
					description: 'alpha_ai.title_section.description',
					image_desktop:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/ALPHA-AI_V4_Top_Banner.jpg?v=1703653531',
					image_mobile:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/CURIE_Plus_V4_ALPHA_AI.png?v=1701671860',
					price: 0.0,
					currencyCode: 'NTD',
					currencySymbol: '$',
					learn_more_url: '',
					learn_more: 'alpha_ai.title_section.learn_more',
					add_to_cart: 'alpha_ai.title_section.add_to_cart',
				},
				icons_section: {
					collateral_items: [
						{
							img_src:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/UVBox_V4_icon_1.png?v=1702274298',
							title: 'alpha_ai.collateral_icons.flyer',
							link: 'https://cdn.ackuretta.com/downloads/alpha-ai/Global_Digital_ALPHA%20AI_Flyer.pdf?v=latest',
							link_US_CA:
								'https://cdn.ackuretta.com/downloads/alpha-ai/Global_Digital_ALPHA%20AI_Flyer.pdf?v=latest',
						},
						{
							img_src:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/ALPHA_AI_V4_icon_2.png?v=1703653530',
							title: 'alpha_ai.collateral_icons.download_upgrade',
							link: 'https://ackuretta.com/pages/video-gallery?videoId=VoLbCy4sE-4',
						},
						{
							img_src:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/User_manual_icon_0a6f887e-ed7e-4ca5-b4e4-2ff699c70238.png?v=1715846640',
							title: 'User Manual',
							link: 'https://cdn.ackuretta.com/downloads/alpha-ai/ALPHA%20AI%20-%20User%20Manual.pdf?v=latest',
						},
						{
							img_src:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/ALPHA_AI_V4_icon_3_5aca8085-ceab-41f0-a6e5-21f7319073ed.png?v=1705488456',
							title: 'alpha_ai.collateral_icons.system_requirements',
							link: 'https://cdn.ackuretta.com/downloads/alpha-ai/ALPHA_AI_system_requirements.pdf?v=latest',
						},
						{
							img_src:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Price-02_2.png?v=1714114876',
							title: 'Premium Pricing',
							link: '#plan-section',
						},
						{
							img_src:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/ALPHA_AI_V4_icon_5.png?v=1725006020',
							title: 'ALPHA AI CAD',
							link: 'https://cdn.ackuretta.com/downloads/alpha-ai/ALPHA%20AI%20CAD%20Functions.pdf',
						},
					],
				},
				feature_section: {
					description: 'alpha_ai.feature_section.description',
					default_img:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/ALPHA_AI_V4_Orient_Stack___Nest.gif?v=1703654229',
					feature_items: [
						{
							title: 'alpha_ai.feature_section.feature_items.item_two.title',
							description: 'alpha_ai.feature_section.feature_items.item_two.description',
							link: null,
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/ALPHA_AI_V4_Orient_Stack___Nest.gif?v=1703654229',
							open: true,
						},
						{
							title: 'alpha_ai.feature_section.feature_items.item_three.title',
							description: 'alpha_ai.feature_section.feature_items.item_three.description',
							link: null,
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/ALPHA_AI_V4_Auto_Supports.gif?v=1703654228',
							open: false,
						},
						{
							title: 'alpha_ai.feature_section.feature_items.item_four.title',
							description: 'alpha_ai.feature_section.feature_items.item_four.description',
							link: null,
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/ALPHA_AI_V4_Slice___Print_Remotely.gif?v=1703654228',
							open: false,
						},
					],
				},
				brands_section: {
					title: 'alpha_ai.brands_section.title',
					brands_list: [
						'argen',
						'arma_dental',
						'bego',
						'curo',
						'dentca',
						'dentona',
						'd_tech',
						'dreve',
						'dmg',
						'ictus_ental',
						'keystone',
						'nextdent',
						'pac_dent',
						'mack4d',
						'nyte3d',
						'voco',
						'saremco',
						'whipmix',
					],
				},
				products_cart_section: {
					product_items: [
						{
							img_src:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/SOL_Plus_V4_Carrousel_1_ALPHA_AI.jpg?v=1747288989',
							title: 'alpha_ai.product_cart_section.product_items.alpha_ai.title',
							description: 'alpha_ai.product_cart_section.product_items.alpha_ai.description',
							page_url:
								'https://ackuretta.com/pages/alpha-ai-slicing-software-for-dental-3d-printing',
							shopifyId: 'gid://shopify/Product/6777579962471',
							variantId: 'gid://shopify/ProductVariant/40179161137255',
							sellingPlanId: 'gid://shopify/SellingPlan/7707689063',
						},
						{
							img_src:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_SOL_42f22b61-0cef-4347-8c7e-dc4068919803.png?v=1699251755',
							title: 'alpha_ai.product_cart_section.product_items.sol.title',
							description: 'alpha_ai.product_cart_section.product_items.sol.description',
							page_url: 'https://ackuretta.com/pages/showcase?product=sol',
							shopifyId: 'gid://shopify/Product/6549949284455',
							variantId: 'gid://shopify/ProductVariant/39309268222055',
							sellingPlanId: null,
						},
						{
							img_src:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Dual_Tanks.png?v=1707216660',
							title: 'alpha_ai.product_cart_section.product_items.cleani_dual_tank.title',
							description:
								'alpha_ai.product_cart_section.product_items.cleani_dual_tank.description',
							page_url: 'https://ackuretta.com/pages/showcase?product=cleani-dual-tank',
							shopifyId: 'gid://shopify/Product/6555508703335',
							variantId: 'gid://shopify/ProductVariant/39332849221735',
							sellingPlanId: null,
						},
						{
							img_src:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/SOL_V4_CURIE_Plus.jpg?v=1700722392',
							title: 'alpha_ai.product_cart_section.product_items.curie_plus.title',
							description: 'alpha_ai.product_cart_section.product_items.curie_plus.description',
							page_url: 'https://ackuretta.com/pages/showcase?product=curie-plus',
							shopifyId: 'gid://shopify/Product/6770993332327',
							variantId: 'gid://shopify/ProductVariant/40137051177063',
							sellingPlanId: null,
						},
						{
							img_src:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/SOL_V4_Ackuretta_Concierge.jpg?v=1700722392',
							title: 'alpha_ai.product_cart_section.product_items.ackuretta_concierge.title',
							description:
								'alpha_ai.product_cart_section.product_items.ackuretta_concierge.description',
							page_url: 'https://ackuretta.com/pages/ackuretta-concierge',
							shopifyId: 'gid://shopify/Product/6779701428327',
							variantId: 'gid://shopify/ProductVariant/40190851186791',
							sellingPlanId: null,
						},
					],
				},
				video_section: {
					title: 'alpha_ai.video_section.title',
					subtitle: null,
					description: 'alpha_ai.video_section.description',
					video:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/ALPHA-AI_V4_Variable_Layer_Thickness.gif?v=1703654229',
				},
				comparison_video_section: {
					title: 'alpha_ai.comparison_video_section.title',
				},
				collection_section: {
					collection_items: [
						{
							img_src:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/ALPHA-AI_V4_50.jpg?v=1703653531',
							title: 'alpha_ai.collection_section.collection_items.item_one.title',
							description: null, //'alpha_ai.collection_section.collection_items.item_one.description'
						},
						{
							img_src:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/ALPHA-AI_V4_70.jpg?v=1703653531',
							title: 'alpha_ai.collection_section.collection_items.item_two.title',
							description: null, //'alpha_ai.collection_section.collection_items.item_two.description'
						},
						{
							img_src:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/ALPHA-AI_V4_100.jpg?v=1703653531',
							title: 'alpha_ai.collection_section.collection_items.item_three.title',
							description: null, //'alpha_ai.collection_section.collection_items.item_three.description'
						},
						{
							img_src:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/ALPHA-AI_V4_150.jpg?v=1703653531',
							title: 'alpha_ai.collection_section.collection_items.item_four.title',
							description: null, //'alpha_ai.collection_section.collection_items.item_four.description'
						},
					],
				},
				scrolling_section: {
					title: 'alpha_ai.scrolling_section.title',
					// description: 'alpha_ai.scrolling_section.description',
					description:
						'ALPHA AI Premium uses AI-powered automatic support creation and orientation for models, crowns, bridges, guides, splints, denture teeth and bases. Its easy-to-use CAD functions enhance productivity for users of all experience levels, reducing the learning curve and allowing dental professionals to delegate and focus more on patient care and less on managing production tools.',
					scrolling_items: [
						{
							// title: 'alpha_ai.scrolling_section.scrolling_items.item_one.title',
							// description: 'alpha_ai.scrolling_section.scrolling_items.item_one.description',
							title: 'Successful Prints Each Time – Save Resin and Labor with AI Functions',
							description:
								'Say goodbye to failed prints: About 75% of print failures are caused by incorrect orientation ans support generation during file prep. ALPHA AI Premium’s automatic features optimize your print setup, saving you both time and resin while maximizing your success rate.',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/ALPHA-AI_V4_Higher_Rate_of_Successful_Prints.jpg?v=1703653531',
						},
						{
							// title: 'alpha_ai.scrolling_section.scrolling_items.item_two.title',
							// description: 'alpha_ai.scrolling_section.scrolling_items.item_two.description',
							title: 'Maximize 3D Printing Efficiency with Three New CAD Features',
							description:
								'Enjoy three new in-app CAD tools for even faster customization:<br>1. <b>Hollow Model</b>: Reduce resin consumption and costs<br>2. <b>Drain Hole</b>: Prevent adhesion issues for reliable prints<br>3. <b>Beveled Edge</b>: Ensure easy, damage-free model removal.<br><br><a href="https://cdn.ackuretta.com/downloads/alpha-ai/ALPHA%20AI%20CAD%20Functions.pdf" >Discover more about ALPHA AI Premium new CAD functions in this detailed overview.</a>',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Hollow_Model_Drain_Holes_2.gif?v=1724746485',
						},
						{
							// title: 'alpha_ai.scrolling_section.scrolling_items.item_three.title',
							// description: 'alpha_ai.scrolling_section.scrolling_items.item_three.description',
							title: 'Access easy-to-use CAD Functions for Versatility and Accuracy',
							description:
								'ALPHA AI Premium offers essential design-editing tools to enhance your workflow. The <b>Trim function</b> allows you to remove unnecessary areas, reducing print times and saving resin. Additionally, the <b>Support Bar function</b> ensures greater accuracy across full-arch applications in few seconds.<br><br><a href="https://cdn.ackuretta.com/downloads/alpha-ai/ALPHA%20AI%20CAD%20Functions.pdf" >Discover more about ALPHA AI Premium new CAD functions in this detailed overview.</a>',
							image: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Trim.gif?v=1724746484',
						},
						{
							title: 'alpha_ai.scrolling_section.scrolling_items.item_four.title',
							description: 'alpha_ai.scrolling_section.scrolling_items.item_four.description',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/ALPHA_AI_V4_Export_50_STL_1.gif?v=1703654227',
						},
						{
							title: 'alpha_ai.scrolling_section.scrolling_items.item_five.title',
							description: 'alpha_ai.scrolling_section.scrolling_items.item_five.description',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/ALPHA_AI_V4_Different_Prints___Multi-selection.gif?v=1703654228',
						},
					],
				},
				testimonials_section: {
					testimonial_items: [
						{
							id: 1,
							name: 'alpha_ai.testimonials_section.testimonial_items.testimonial_one.name',
							title: 'alpha_ai.testimonials_section.testimonial_items.testimonial_one.title',
							quote: 'alpha_ai.testimonials_section.testimonial_items.testimonial_one.description',
							img_src:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/KOL_Testimonials_Adam_Nulty.jpg?v=1705894661',
							altText: 'First slide',
						},
						{
							id: 2,
							name: 'alpha_ai.testimonials_section.testimonial_items.testimonial_two.name',
							title: 'alpha_ai.testimonials_section.testimonial_items.testimonial_two.title',
							quote: 'alpha_ai.testimonials_section.testimonial_items.testimonial_two.description',
							img_src:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/seth-potter.png?v=1663033971',
							altText: 'Second slide',
						},
						{
							id: 3,
							name: 'alpha_ai.testimonials_section.testimonial_items.testimonial_three.name',
							title: 'alpha_ai.testimonials_section.testimonial_items.testimonial_three.title',
							quote:
								'alpha_ai.testimonials_section.testimonial_items.testimonial_three.description',
							img_src:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Nicolas_1.png?v=1666748143',
							altText: 'Third slide',
						},
					],
				},
				plan_section: {
					activeTab: 'two-years',
					tab_items: [
						{
							id: 'two-years',
							name: 'alpha_ai.plan_section.plan_items.two_years.title',
							standard: 'alpha_ai.plan_section.plan_items.two_years.standard',
							premium: 'alpha_ai.plan_section.plan_items.two_years.premium',
							href: '#two-years',
							free_price: 'alpha_ai.plan_section.plan_items.two_years.free_price',
							old_price: 'alpha_ai.plan_section.plan_items.two_years.old_price',
							new_price: 'alpha_ai.plan_section.plan_items.two_years.new_price',
							duration: 'alpha_ai.plan_section.plan_items.two_years.price_description',
							button_text_free: 'alpha_ai.plan_section.plan_items.two_years.button_text_free',
							button_text_premium: 'alpha_ai.plan_section.plan_items.two_years.button_text_premium',
							activeTab: true,
							features: [
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_one',
									included_free: true,
									included_premium: true,
								},
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_two',
									included_free: true,
									included_premium: true,
								},
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_three',
									included_free: true,
									included_premium: true,
								},
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_four',
									image:
										'https://cdn.shopify.com//s//files//1//0276//4174//1415//files//3shape.png?v=1656400700',
									image_2:
										'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Clinux_logo.png?v=1672120841',
									included_free: true,
									included_premium: true,
								},
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_five',
									image:
										'https://cdn.shopify.com//s//files//1//0276//4174//1415//files//exocad.png?v=1656400700',
									image_2:
										'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/mdeit.png?v=1656400700',
									included_free: true,
									included_premium: true,
								},
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_five',
									image:
										'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/c1789b85-d9e6-4c02-a688-c97132d14af5_1_1.png?v=1721723234',
									image_2: null,
									included_free: true,
									included_premium: true,
								},
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_six',
									included_free: true,
									included_premium: true,
								},
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_seven',
									included_free: true,
									included_premium: true,
								},
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_thirteen',
									included_free: true,
									included_premium: true,
								},
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_eight',
									included_free: false,
									included_premium: true,
								},
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_nine',
									included_free: false,
									included_premium: true,
								},
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_fourteen',
									included_free: false,
									included_premium: true,
								},
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_ten',
									included_free: false,
									included_premium: true,
								},
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_eleven',
									included_free: false,
									included_premium: true,
								},
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_twelve',
									included_free: null,
									included_premium: null,
									include_number: true,
								},
							],
						},
						{
							id: 'yearly',
							name: 'alpha_ai.plan_section.plan_items.yearly.title',
							standard: 'alpha_ai.plan_section.plan_items.yearly.standard',
							premium: 'alpha_ai.plan_section.plan_items.yearly.premium',
							href: '#yearly',
							free_price: 'alpha_ai.plan_section.plan_items.yearly.free_price',
							old_price: 'alpha_ai.plan_section.plan_items.yearly.old_price',
							new_price: 'alpha_ai.plan_section.plan_items.yearly.new_price',
							duration: 'alpha_ai.plan_section.plan_items.yearly.price_description',
							button_text_free: 'alpha_ai.plan_section.plan_items.yearly.button_text_free',
							button_text_premium: 'alpha_ai.plan_section.plan_items.yearly.button_text_premium',
							activeTab: true,
							features: [
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_one',
									included_free: true,
									included_premium: true,
								},
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_two',
									included_free: true,
									included_premium: true,
								},
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_three',
									included_free: true,
									included_premium: true,
								},
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_four',
									image:
										'https://cdn.shopify.com//s//files//1//0276//4174//1415//files//3shape.png?v=1656400700',
									image_2:
										'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Clinux_logo.png?v=1672120841',
									included_free: true,
									included_premium: true,
								},
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_five',
									image:
										'https://cdn.shopify.com//s//files//1//0276//4174//1415//files//exocad.png?v=1656400700',
									image_2:
										'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/mdeit.png?v=1656400700',
									included_free: true,
									included_premium: true,
								},
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_five',
									image:
										'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/c1789b85-d9e6-4c02-a688-c97132d14af5_1_1.png?v=1721723234',
									image_2: null,
									included_free: true,
									included_premium: true,
								},
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_six',
									included_free: true,
									included_premium: true,
								},
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_seven',
									included_free: true,
									included_premium: true,
								},
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_thirteen',
									included_free: true,
									included_premium: true,
								},
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_eight',
									included_free: false,
									included_premium: true,
								},
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_nine',
									included_free: false,
									included_premium: true,
								},
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_fourteen',
									included_free: false,
									included_premium: true,
								},
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_ten',
									included_free: false,
									included_premium: true,
								},
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_eleven',
									included_free: false,
									included_premium: true,
								},
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_twelve',
									included_free: null,
									included_premium: null,
									include_number: true,
								},
							],
						},
						{
							id: 'monthly',
							name: 'alpha_ai.plan_section.plan_items.monthly.title',
							standard: 'alpha_ai.plan_section.plan_items.monthly.standard',
							premium: 'alpha_ai.plan_section.plan_items.monthly.premium',
							href: '#monthly',
							free_price: 'alpha_ai.plan_section.plan_items.monthly.free_price',
							old_price: null,
							new_price: 'alpha_ai.plan_section.plan_items.monthly.new_price',
							duration: 'alpha_ai.plan_section.plan_items.monthly.price_description',
							button_text_free: 'alpha_ai.plan_section.plan_items.monthly.button_text_free',
							button_text_premium: 'alpha_ai.plan_section.plan_items.monthly.button_text_premium',
							activeTab: true,
							features: [
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_one',
									included_free: true,
									included_premium: true,
								},
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_two',
									included_free: true,
									included_premium: true,
								},
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_three',
									included_free: true,
									included_premium: true,
								},
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_four',
									image:
										'https://cdn.shopify.com//s//files//1//0276//4174//1415//files//3shape.png?v=1656400700',
									image_2:
										'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Clinux_logo.png?v=1672120841',
									included_free: true,
									included_premium: true,
								},
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_five',
									image:
										'https://cdn.shopify.com//s//files//1//0276//4174//1415//files//exocad.png?v=1656400700',
									image_2:
										'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/mdeit.png?v=1656400700',
									included_free: true,
									included_premium: true,
								},
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_five',
									image:
										'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/c1789b85-d9e6-4c02-a688-c97132d14af5_1_1.png?v=1721723234',
									image_2: null,
									included_free: true,
									included_premium: true,
								},
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_six',
									included_free: true,
									included_premium: true,
								},
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_seven',
									included_free: true,
									included_premium: true,
								},
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_thirteen',
									included_free: true,
									included_premium: true,
								},
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_eight',
									included_free: false,
									included_premium: true,
								},
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_nine',
									included_free: false,
									included_premium: true,
								},
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_fourteen',
									included_free: false,
									included_premium: true,
								},
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_ten',
									included_free: false,
									included_premium: true,
								},
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_eleven',
									included_free: false,
									included_premium: true,
								},
								{
									name: 'alpha_ai.plan_section.plan_items.features.feature_twelve',
									included_free: null,
									included_premium: null,
									include_number: true,
								},
							],
						},
					],
				},
			},
		};
	},
	methods: {
		//...Vuex.mapActions(['sayHi', 'someAction']),
		//...Vuex.mapActions('sliders', ['getSlideList'])
	},
	beforeDestroy() {},
	watch: {
		data1: {
			handler() {},
			deep: false,
		},
	},
});
